import { render, staticRenderFns } from "./EnIntDataWorkspace.vue?vue&type=template&id=1368c43b&scoped=true"
import script from "./EnIntDataWorkspace.vue?vue&type=script&lang=js"
export * from "./EnIntDataWorkspace.vue?vue&type=script&lang=js"
import style0 from "./EnIntDataWorkspace.vue?vue&type=style&index=0&id=1368c43b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1368c43b",
  null
  
)

export default component.exports